import { Component, OnInit } from '@angular/core';
import { FieldConfig } from 'src/app/core/interfaces/field-config';
import { UntypedFormGroup } from '@angular/forms';
import { DynamicFormServiceService} from 'src/app/shared/services/dynamic-form-service.service';
import { BroadcastService } from 'src/app/shared/services/broadcast.service';

@Component({
    selector: 'app-select-form',
    templateUrl: './select-form.component.html',
    styleUrls: ['./select-form.component.scss'],
    standalone: false
})
export class SelectFormComponent implements OnInit {

  constructor(private dynamicService: DynamicFormServiceService, private broadCastService: BroadcastService) { }
  field: FieldConfig;
  group: UntypedFormGroup;
  sortedOptions: any;
  isRequired: boolean;

  ngOnInit() {
   this.sortedOptions = this.sortedSequence();
   this.isRequired = this.dynamicService.checkHasRequired(this.field);
  }

  afterSelection(event) {
    if (this.field.childAoeDtos && this.field.childAoeDtos.length > 0) {
      const labelCodeExist = this.dynamicService.revealChildLabelCodes(this.field.childAoeDtos, event.value, this.field.labelCode);
      const childAllLabelCodes = this.dynamicService.getAllChildAOEcodeFomParent(this.field);
      if (childAllLabelCodes) { this.broadCastService.broadcast('CLEAR_OPTIONS', childAllLabelCodes); }
      if (labelCodeExist !== -1) {
        this.broadCastService.broadcast('SHOW_OPTIONS', labelCodeExist);
      }
    }
  }

  private sortedSequence() {
    if (this.field && this.field.options) {
      return ((this.field.labelCode === 'SONOID' ||
        this.field.labelCode === 'SSUPER') ?
        this.field.options.sort((a, b) => {
          const left = a.value.toUpperCase();
          const right = b.value.toUpperCase();
          if (left < right) {
            return -1;
          }
          if (left > right) {
            return 1;
          }
          return 0;
        }) : this.field.options.sort((a, b) => a.sequence - b.sequence));
      }
  }
}
